/*
		base.js,
			Very simple helper functions with no dependencies.

		WARNING: don't use in a mozilla extension. It messes too much with the javascript context.
 */


var $A = module.exports.$A = function(pseudo) {
	var real = [];
	for(var i = 0; i < pseudo.length; i++) {
		real.push(pseudo[i]);
	}
	return real;
}

module.exports.$ = function() {
	var elements = [];

	for(var i = 0; i < arguments.length; i++) {
		var element = arguments[i];
		if(typeof element == 'string') {
			element = document.getElementById(element);
		}

		if(arguments.length == 1) {
			return element;
		}

		elements.push(element);
	}

	return elements;
}


Object.extend = function(destination, source) {
	for (property in source) {
		destination[property] = source[property];
	}
	return destination;
}

Object.optextend = function(destination, source) {
	for (property in source) {
		if(destination[property] == undefined) {
			destination[property] = source[property];
		}
	}
	return destination;
}

/* from http://www.brockman.se/writing/method-references.html.utf8 +/
Function.prototype.bind = function(object) {
	var method = this;
	var oldArguments = $A(arguments).slice(1);
	return function() {
		var newArguments = $A(arguments);
		return method.apply(object, oldArguments.concat(newArguments));
	};
} NOTE: should be handled by es5-shim */

module.exports.copy = function(obj, props) {
	if(! props) {
		return;
	}
	for(var key in props) {
//		if(props.hasOwnProperty(key))
		obj[key] = props[key];
	}
}

